if (!global.Intl) {
    require('intl');
    require('intl/locale-data/jsonp/en.js');
    require('intl/locale-data/jsonp/ru.js');
    require('intl/locale-data/jsonp/uz.js');
    require('intl/locale-data/jsonp/kk.js');
}



// WEBPACK FOOTER //
// ./src/intl-polyfill.js